import { Navigate, useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import {
  CompetenciesEmployeesRootPageDocument,
  CompetenciesEmployeesRootPageQuery,
} from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/competencies/lib/EmployeesCollectionsBootstrap'
import type { RouteContext } from 'modules/employees/lib/types'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Component from './Competencies'

interface ContainerProps {
  data?: CompetenciesEmployeesRootPageQuery
  loadingModuleAvailabilities: boolean
  hasCompetencies: boolean
}

const Container = ({ data, loadingModuleAvailabilities, hasCompetencies }: ContainerProps) => {
  const { navigation } = useNavigation()

  const canManageCompetencies = data?.competencies._policies.competenciesManage.can ?? false

  if (loadingModuleAvailabilities)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )

  if (!hasCompetencies && canManageCompetencies)
    return <Navigate replace to={navigation.discover.marketplaceModules.fullPath()} />

  if (!hasCompetencies) return <NotFound />

  return <Component assessmentGroups={data?.competencies.assessmentGroups} />
}

const RootPage = () => {
  const { hasCompetencies, loadingModuleAvailabilities, employee } =
    useOutletContext<RouteContext>()

  const { loading, data, error } = useQuery(CompetenciesEmployeesRootPageDocument, {
    variables: {
      targetEmployeeIds: [employee.id.toString()],
    },
  })

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <CollectionsBootstrap>
        <Container
          data={data}
          loadingModuleAvailabilities={loadingModuleAvailabilities}
          hasCompetencies={hasCompetencies}
        />
      </CollectionsBootstrap>
    </ResponsivePage.Body>
  )
}

export default RootPage
